import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ClipboardList, ArrowUpRight } from "lucide-react";

const STATUS_STYLE = {
  new: "bg-blue-50 text-blue-700",
  in_progress: "bg-amber-50 text-amber-700",
  converted: "bg-emerald-50 text-emerald-700",
  rejected: "bg-gray-100 text-gray-500",
};
const statusLabel = (s) => ({ new: "New", in_progress: "In progress", converted: "Converted", rejected: "Rejected" }[s] || s);

export default function DashboardIntakes() {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/intakes/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div className="bg-white border border-gray-200 rounded-sm p-6 shadow-sm" data-testid="dashboard-intakes-widget">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-heading text-lg font-bold text-gray-900 flex items-center gap-2">
          <ClipboardList className="w-5 h-5 text-[#002FA7]" /> Intake
        </h3>
        <button onClick={() => navigate("/intake")} data-testid="dashboard-intakes-open"
          className="text-xs font-semibold text-[#002FA7] hover:underline flex items-center gap-1">
          Open <ArrowUpRight className="w-3.5 h-3.5" />
        </button>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-4">
        <button onClick={() => navigate("/intake")} data-testid="intake-stat-new"
          className="text-left bg-blue-50/60 rounded-sm p-3 hover:bg-blue-50 transition-colors">
          <p className="font-heading text-2xl font-extrabold text-blue-700">{stats?.by_status?.new ?? "—"}</p>
          <p className="text-xs font-semibold text-gray-500 mt-0.5">New leads</p>
        </button>
        <button onClick={() => navigate("/intake")} data-testid="intake-stat-week"
          className="text-left bg-gray-50 rounded-sm p-3 hover:bg-gray-100 transition-colors">
          <p className="font-heading text-2xl font-extrabold text-gray-900">{stats?.new_this_week ?? "—"}</p>
          <p className="text-xs font-semibold text-gray-500 mt-0.5">This week</p>
        </button>
      </div>

      {stats?.recent?.length ? (
        <div className="space-y-2" data-testid="dashboard-intakes-recent">
          {stats.recent.map((it) => (
            <button key={it.id} onClick={() => navigate("/intake")} data-testid={`dashboard-intake-${it.id}`}
              className="w-full flex items-center gap-2 text-left py-1.5 hover:bg-gray-50 rounded-sm px-1 transition-colors">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-gray-900 truncate">{it.name}</p>
                <p className="text-xs text-gray-400 truncate">{it.case_type || "No case type"}</p>
              </div>
              <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full shrink-0 ${STATUS_STYLE[it.status] || ""}`}>
                {statusLabel(it.status)}
              </span>
            </button>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-400">No intakes yet.</p>
      )}
    </div>
  );
}
